module.exports = __webpack_public_path__ + "static/media/icon-add-question.b5859b77.svg";